import axios from "axios";

export const ACS_API_BASE = "https://apis.num-mfs.com/acs-admin/api/";

export const ACS_ENDPOINTS = {
  login: "login/",
  logout: "logout/",
  conversion: "reports/conversion/",
  denominations: "reports/denominations/",
  revenue: "reports/management/revenue/",
  lending: "reports/management/lending/",
  topup: "reports/management/topup/",
  penetration: "reports/management/penetration/",
  usage: "reports/management/usage/",
};

export const fetchAcsReport = async (endpoint, { start, end } = {}) => {
  const params = {};
  if (start) params.start = start;
  if (end) params.end = end;
  const response = await axios.get(`${ACS_API_BASE}${ACS_ENDPOINTS[endpoint]}`, {
    withCredentials: true,
    params,
  });
  return response.data || {};
};
